import { createContext, useContext } from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { useReadAccess } from 'src/app/AppAuth/useReadAccess'
import { filterRequiredCapabilities } from './FilterPermissions.config'

export const FilterCapabilitiesContext = createContext<CAPABILITY[]>([])

export const useFilterCapabilities = (
  param: string,
  requiredCapabilities?: CAPABILITY[],
): { capabilities: CAPABILITY[]; allowed: boolean } => {
  const inherited = useContext(FilterCapabilitiesContext)
  const capabilities = [
    ...inherited,
    ...(requiredCapabilities ?? filterRequiredCapabilities(param)),
  ]
  return { capabilities, allowed: useReadAccess(...capabilities) }
}
